<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
.v-application {
  background-color: var(--v-background-base) !important;
}
</style>
